import { AppModule } from 'app/module';
import 'module/icon/main';
import Template from './template.hbs';
import './styles.scss';

export class CompanyBenefits extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            toggleShowMore: '.m-companyBenefits__toggleShowMore',
            list: '.m-companyBenefits__list',
            items: ['.m-companyBenefits__item'],
        };
    }

    getPropsFromDom() {
        let i = 0;
        let iconType = '';
        const newProps = {
            benefits: {},
        };

        Array.prototype.forEach.call(this.dom.items, (item) => {
            newProps.benefits[i] = {
                title: '',
                text: '',
                icon: {},
            };
            newProps.benefits[i].title = item.querySelector('.m-companyBenefits__title').innerText;
            newProps.benefits[i].text = item.querySelector('.m-companyBenefits__block') !== null
                ? item.querySelector('.m-companyBenefits__block').innerText : '';

            iconType = item.querySelector('.m-companyBenefits__icon').getAttribute('data-icon-type');
            newProps.benefits[i].icon[iconType] = true;

            i += 1;
        });

        return { active: !!this.dom.list,
            showMore: false,
            hasMore: !!this.dom.toggleShowMore,
            ...newProps };
    }

    domEvents() {
        if (this.dom.toggleShowMore) {
            this.dom.toggleShowMore.addEventListener('click', (e) => { this.toggleCompanyFacts(e); });
        }
    }

    toggleCompanyFacts(e) {
        if (e) e.preventDefault();
        this.updateProps({ showMore: !this.props.showMore }, true);
    }

    afterRender() {
        if (window.self !== window.parent) {
            this.events.emit('updateIFrame');
        }
    }
}
